'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported from "./presto.-Two-Factor-Auth-View$-Imported.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$48(failed$3) {
  this.XI = null;
  this.XI = failed$3;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$48 as $c_Lpresto_TwoFactorAuthView$$anon$48 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$48;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$48() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$48 as $h_Lpresto_TwoFactorAuthView$$anon$48 };
$h_Lpresto_TwoFactorAuthView$$anon$48.prototype = $p;
$p.adI = (function(x) {
  return (this.XI.aE(x.hX) || (!x.iv.k()));
});
$p.abK = (function(x, default$1) {
  if (this.XI.aE(x.hX)) {
    var error$2 = this.XI.bu(x.hX);
    return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported.$c_Lpresto_TwoFactorAuthView$Imported(x.hX, x.tM, x.on, x.iv, error$2);
  } else {
    return ((!x.iv.k()) ? x : default$1.w(x));
  }
});
$p.cb = (function(x) {
  return this.adI(x);
});
$p.bk = (function(x, default$1) {
  return this.abK(x, default$1);
});
var $d_Lpresto_TwoFactorAuthView$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$48, "presto.TwoFactorAuthView$$anon$48", ({
  T7: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$48 as $d_Lpresto_TwoFactorAuthView$$anon$48 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$48.js.map
